/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
import { Checkbox } from 'antd';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useIsExactChecked } from '@core/offices/actions/properties/filterActions';
import { usePropertyFilters } from '@core/offices/store/filters';
import { COMPONENT_TYPE, LocationFilter } from '@core/offices/types';

interface Props {
  filter: LocationFilter;
}

const CheckboxWrapper = styled.div`
  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: var(--secondary) !important;
    background-color: var(--secondary) !important;
    ::after {
      border-color: black;
    }
  }
`;

export const ExactCheckbox: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { updateExactValue } = usePropertyFilters();
  const { isExactChecked } = useIsExactChecked(props.filter);
  const type = props.filter.componentType;

  const optionValue = useMemo(() => {
    if (props.filter.options && props.filter.options.length > 0) {
      if (typeof props.filter.options[0] === 'object') {
        return props.filter.options[0].value;
      }
      return props.filter.options[0];
    }
    return null;
  }, [props.filter.options]);

  if (
    props.filter.secondaryOperator &&
    ((type === COMPONENT_TYPE.RADIO && optionValue && typeof parseInt(optionValue as string, 10) === 'number') ||
      (type === COMPONENT_TYPE.CHECKBOX &&
        optionValue &&
        typeof parseInt(optionValue as string, 10) === 'number' &&
        props.filter.isMultiSelect === '0') ||
      type === COMPONENT_TYPE.NUMBER)
  ) {
    return (
      <CheckboxWrapper>
        <Checkbox
          disabled={isExactChecked === undefined}
          checked={isExactChecked}
          className="ms-2"
          onChange={(e) => {
            updateExactValue(props.filter.fieldName, e.target.checked);
          }}
        >
          <p className="text-gray-500 text-sm">{t('filters.useExactValue')}</p>
        </Checkbox>
      </CheckboxWrapper>
    );
  }
  return null;
};
